import BrokenToothRFV from '@/assets/SVG/BrokenToothRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const BrokenTooth = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconBrokenTooth,
			} as React.CSSProperties
		}
	>
		<BrokenToothRFV />
	</div>
);
